import instanceAxios from './axiosConfig';
import { URL} from '../utility/util';

const storeTranscriptDetails = async (InitialContactId, Transcript ) => {

    let req = URL.PARAMS.STORE_TRANSCRIPT_DETAILS;
    req.InitialContactId = InitialContactId;
    req.Transcript        = Transcript;
    
    return new Promise((resolve, reject) => {
        instanceAxios.post('/mso-chat', req )
        .then((response) => {
            resolve(response.data.data);
        })
        .catch(error => {
            reject(error);
        })
    })
    
  };

  const getTranscriptDB = async (InitialContactId) => {

    let req = URL.PARAMS.GET_TRANSCRIPT;
    req.InitialContactId = InitialContactId;
    
    return new Promise((resolve, reject) => {
        instanceAxios.post('/mso-chat', req )
        .then((response) => {
            resolve(response.data.data);
        })
        .catch(error => {
            reject(error);
        })
    })
    
  };
  
  export { storeTranscriptDetails, getTranscriptDB };